var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6016 14C15.841 14 16.4682 15.4113 15.5908 16.2344L11.9834 19.6182C11.4402 20.1275 10.5626 20.1276 10.0195 19.6182L6.41309 16.2344C5.53572 15.4113 6.14827 14 7.3877 14H14.6016ZM11 10C11.5523 10 12 10.4477 12 11C12 11.5523 11.5523 12 11 12C10.4477 12 10 11.5523 10 11C10 10.4477 10.4477 10 11 10ZM10.0166 2.38184C10.5598 1.87252 11.4374 1.87238 11.9805 2.38184L15.5869 5.76562C16.4643 6.58869 15.8517 7.99996 14.6123 8H7.39844C6.15897 8 5.53181 6.58871 6.40918 5.76562L10.0166 2.38184Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/ScrollIcon.ef666a2c52e37c50ec15dc3f8302eb09.svg";
export { ForwardRef as ReactComponent };